<div class="exercise-container">
  <div class="exercise-nav-bar box">
    <div class="exercise-nav-bar-title">افزودن فعالیت</div>
    <div class="exercise-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="exercise-holder box">
    <div class="search-box">
      <div class="icon">
        <img src="assets/general/search-blue.svg" />
      </div>
      <div class="input">
        <input
          type="text"
          (keydown)="onkeydown($event)"
          [(ngModel)]="searchText"
          (ngModelChange)="search($event)"
          autocomplete="off"
          (focus)="openHistory()"
          [placeholder]="isFocuse ? '' : 'جست‌وجوی فعالیت'"
        />
      </div>
    </div>

    <div
      class="custome-button"
      *ngIf="!isFocuse"
      (click)="openCustomeExercise()"
    >
      <div class="add-button">
        <img src="assets/plan/plus.svg" alt="" />
      </div>
      <p class="title">ثبت سریع کالری</p>
    </div>
    <div
      class="search-result"
      *ngIf="
        isFocuse && !exercises && showHistory && history && history.length > 0
      "
    >
      <h1 class="recent">جستجو اخیر</h1>
      <div class="search-result-item" *ngFor="let exercise of history">
        <p (click)="openExercise(exercise, true)">{{ exercise.name }}</p>
        <img
          (click)="removeExercise(exercise)"
          src="assets/general/cross-blue.svg"
          alt=""
        />
      </div>
    </div>
    <div class="search-result" *ngIf="isFocuse && exercises && !showHistory">
      <div
        class="search-result-item"
        (click)="openExercise(exercise)"
        *ngFor="let exercise of exercises"
      >
        <p>{{ exercise.name }}</p>
        <img src="assets/general/left-gray.svg" alt="" />
      </div>
    </div>
  </div>
  <app-bottomsheet *ngIf="customeExrecise" [type]="type"></app-bottomsheet>
</div>
